var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-2",attrs:{"headers":_vm.fields,"items":_vm.lignes,"loading":_vm.isLoading,"dense":"","disable-sort":"","locale":"fr-FR","no-results-text":"Aucun article trouvé","items-per-page":50,"items-per-page-options":[20, 50, 100, -1],"footer-props":{
              'items-per-page-text': 'Lignes par pages:',
              'page-text': '{0}-{1} sur {2}',
              'items-per-page-all-text': 'Toutes',
              'items-per-page': 20,
              'items-per-page-options': [20, 50, 100, -1]
            }},scopedSlots:_vm._u([{key:"item.fabriquant_marque",fn:function(ref){
            var item = ref.item;
return [(item.article)?_c('span',[_vm._v(_vm._s(item.article.fabriquantMarque))]):_vm._e()]}},{key:"item.designation",fn:function(ref){
            var item = ref.item;
return [(item.ligne)?_c('span',[_vm._v(_vm._s(item.ligne.designation))]):_vm._e()]}},{key:"item.softId",fn:function(ref){
            var item = ref.item;
return [(item.ligne)?_c('span',[_vm._v(_vm._s(item.ligne.articleSoftId))]):_vm._e()]}},{key:"item.quantite",fn:function(ref){
            var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.quantiteMouvement))])]}},{key:"item.prixAchat",fn:function(ref){
            var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.montantRetrocession)+" €")])]}},{key:"item.dateVente",fn:function(ref){
            var item = ref.item;
return [(item.ligne && item.ligne.entete)?_c('span',[_vm._v(_vm._s(_vm._f("moment")(item.ligne.entete.dateHeureDebut,"DD/MM/YYYY")))]):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }